module.exports = __webpack_public_path__ + "img/waterfall-en-1.4bf6604.svg";